// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jzMc","col":"styles_col__1W-j8"};